import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje} from '../components/mensajes';

import useTable from "../components/useTable"
import Controls from "../components/controls/Controls";

import { Dimmer} from '../components/spinner';

import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import axios from 'axios';




const CatalogoUsuarioWeb = props => {


    const headCells = [
        { id: 'login', label: 'LOGIN', width: '200px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: 'cedularif', label: 'CEDULA/RIF', width: '50px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: 'nombre', label: 'NOMBRE', width: '300px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: 'idusuarioweb', label: 'ID USUARIO', width: '30px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: 'accion', label: '', width: '120px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
    ]
    

    let token = localStorage.getItem('jwtToken');
    let op = require('../../src/modulos/datos');

    const btnCancela = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.login.toLowerCase().includes(target.value.toLowerCase())
                            || x.cedularif.toLowerCase().includes(target.value.toLowerCase())
                            || x.nombre.toLowerCase().includes(target.value.toLowerCase())
                            || x.idusuarioweb.includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }



    const datosUsuWeb = () => {

        let campos = '*';
        let nomtab = 'usuarioweb';
        let orden = 'idusuarioweb';

        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                setActivate(false);

                if (response.data.length > 0) {

                    var usuw = []
                    for (let i = 0; i < response.data.length; i++) {
                        usuw.push({
                            login: response.data[i].login,
                            cedularif: response.data[i].nacionalidad+'-'+response.data[i].cedula,
                            cedula: response.data[i].cedula,
                            nombre: response.data[i].nombre,
                            idusuarioweb: response.data[i].idusuarioweb,
                            dirip: response.data[i].dirip,
                            email2: response.data[i].email2,
                            estatus: response.data[i].estatus,
                            idcomercio: response.data[i].idcomercio,
                            nacionalidad: response.data[i].nacionalidad,
                            direccion: response.data[i].direccion,
                            passwd: response.data[i].nacionalidad,
                            rif: response.data[i].rif,
                            telefono: response.data[i].rif
                        })
                    }
                    setRecords(usuw)
                    
                }

            }

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }


    const blanquear = () => {

        setMostrar(false);
        setTitulo('');
        setMsg('');
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
    }


    const handleCloseMensa = () => {
        setMostrar(false);
            datosUsuWeb();
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelaCatUsuWeb();
    }

    const seleccionarUsuarioWeb = (index) => (event) => {
        var login = recordsAfterPagingAndSorting()[index].login;
        var nomUsuW = recordsAfterPagingAndSorting()[index].nombre;
        var idUsuW = recordsAfterPagingAndSorting()[index].idusuarioweb;
        blanquear();
        props.onHideAceptaCatUsuW(login, nomUsuW, idUsuW);


    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                datosUsuWeb()
            }}
        >
            <Modal.Header style={{ backgroundColor: "#019cd5" }}>
                <Modal.Title style={{ color: "#fff" }}>Seleccionar Personas.</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 m-0">

<div className="input-group input-group-sm mb-3 m-0 col-md-5">
    <input type='text'
        onChange={handleSearch} className="form-control rounded-pill search-input" />
</div>
</div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item.cedula} style={{ padding: "0" }}>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "200px", verticalAlign: "middle" }}>{item.login}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "50px", verticalAlign: "middle" }}>{item.cedularif}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "300px", verticalAlign: "middle" }}>{item.nombre}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "30px", verticalAlign: "middle" }}>{item.idusuarioweb}</td>
                                        <td align="center" style={{ fontSize: "10px", textAlign: "center", width: "120px", padding: 0, verticalAlign: "middle" }}>
                                            <button style={{ width: "120px" }} onClick={seleccionarUsuarioWeb(index)} className="btn btn-outline-info"><i className="fas fa-edit">Seleccionar</i> </button>
                                        </td>
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-danger col-md-2"><i className="fa"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoUsuarioWeb;